const state = {
  levelList: []
};

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};

const actions = {
  changeSetting({ commit }, data) {
    commit("CHANGE_SETTING", data);
  }
};

const getters = {
  getLevelList(state) {
    return state.levelList;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/settings.js